module.exports = __webpack_public_path__ + "img/success-popup-icon.aaab9cf8.svg";